import { Button } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1, 1.5),
    backgroundColor: "#387002",
    color: "white",
    borderColor: "#387002",
    "&:hover": {
      backgroundColor: "white",
      color: "#387002",
    }
  },
  paragraph: {
    padding: ".5em 0",
    // fontSize: "1.2em",
  },
}));

export default function ContactButton({ item }) {
  const classes = useStyles();

  return (
    <Button variant="outlined" href={item.link} className={classes.button} style={{  }}>
      <Typography className={classes.paragraph} variant="h6">{item.displayText}</Typography>
    </Button>
  )
}